import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4e5b4ea8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4e5b4ea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5b4ea8",
  null
  
)

/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseUiBreadcrumb: require('/var/www/html/intelli.com.br/components/base/ui/Breadcrumb.vue').default,BaseUiSearch: require('/var/www/html/intelli.com.br/components/base/ui/Search.vue').default,BaseUiMultiselect: require('/var/www/html/intelli.com.br/components/base/ui/Multiselect.vue').default,BaseUiCardNews: require('/var/www/html/intelli.com.br/components/base/ui/CardNews.vue').default,BaseUiPagination: require('/var/www/html/intelli.com.br/components/base/ui/Pagination.vue').default,BaseUiNewsletter: require('/var/www/html/intelli.com.br/components/base/ui/Newsletter.vue').default,BaseUiNoResultsFounded: require('/var/www/html/intelli.com.br/components/base/ui/NoResultsFounded.vue').default})
